import { useEffect, useState } from 'react';

export const useNetworkStatus = (callBack?: (online?: boolean) => void) => {
  const [online, setOnline] = useState('onLine' in navigator ? navigator.onLine : true);

  const updateOnlineStatus = () => {
    const status = navigator.onLine;

    if (callBack) {
      callBack(status);
    }
    setOnline(navigator.onLine);
  };

  useEffect(() => {
    addEventListener('offline', updateOnlineStatus);
    addEventListener('online', updateOnlineStatus);

    return () => {
      removeEventListener('offline', updateOnlineStatus);
      removeEventListener('online', updateOnlineStatus);
    };
  }, []);

  return { online };
};
